/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { CreateFlightTypeRequest } from '../models/create-flight-type-request';
import { FlightTypeResponse } from '../models/flight-type-response';
import { GenericResponse } from '../models/generic-response';
import { GetFlightTypeResponse } from '../models/get-flight-type-response';
import { UpdateFlightTypeRequest } from '../models/update-flight-type-request';

/**
 * flight type apis
 */
@Injectable({ providedIn: 'root' })
export class FlightTypeService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllFlightType()` */
  static readonly GetAllFlightTypePath = '/api/v1/flight-types';

  /**
   * Get list of flight types.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllFlightType()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllFlightType$Response(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * This adds a string search to the following fields:
       * - type
       */
      search?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GetFlightTypeResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      FlightTypeService.GetAllFlightTypePath,
      'get'
    );
    if (params) {
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
      rb.query('sort', params.sort, {});
      rb.query('search', params.search, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GetFlightTypeResponse>;
        })
      );
  }

  /**
   * Get list of flight types.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllFlightType$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllFlightType(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * This adds a string search to the following fields:
       * - type
       */
      search?: string;
    },
    context?: HttpContext
  ): Observable<GetFlightTypeResponse> {
    return this.getAllFlightType$Response(params, context).pipe(
      map(
        (r: StrictHttpResponse<GetFlightTypeResponse>): GetFlightTypeResponse =>
          r.body
      )
    );
  }

  /** Path part for operation `createFlightType()` */
  static readonly CreateFlightTypePath = '/api/v1/flight-types';

  /**
   * Create new flight type.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createFlightType()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createFlightType$Response(
    params: {
      body: CreateFlightTypeRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<FlightTypeResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      FlightTypeService.CreateFlightTypePath,
      'post'
    );
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<FlightTypeResponse>;
        })
      );
  }

  /**
   * Create new flight type.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createFlightType$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createFlightType(
    params: {
      body: CreateFlightTypeRequest;
    },
    context?: HttpContext
  ): Observable<FlightTypeResponse> {
    return this.createFlightType$Response(params, context).pipe(
      map(
        (r: StrictHttpResponse<FlightTypeResponse>): FlightTypeResponse =>
          r.body
      )
    );
  }

  /** Path part for operation `getFlightTypeById()` */
  static readonly GetFlightTypeByIdPath = '/api/v1/flight-types/{id}';

  /**
   * fetch flight  type by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFlightTypeById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFlightTypeById$Response(
    params: {
      /**
       * The flight type's id that needs to be fetched
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<FlightTypeResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      FlightTypeService.GetFlightTypeByIdPath,
      'get'
    );
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<FlightTypeResponse>;
        })
      );
  }

  /**
   * fetch flight  type by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFlightTypeById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFlightTypeById(
    params: {
      /**
       * The flight type's id that needs to be fetched
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<FlightTypeResponse> {
    return this.getFlightTypeById$Response(params, context).pipe(
      map(
        (r: StrictHttpResponse<FlightTypeResponse>): FlightTypeResponse =>
          r.body
      )
    );
  }

  /** Path part for operation `deleteFlightType()` */
  static readonly DeleteFlightTypePath = '/api/v1/flight-types/{id}';

  /**
   * Delete flight type by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteFlightType()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteFlightType$Response(
    params: {
      /**
       * The flight type's id that needs to be deleted
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GenericResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      FlightTypeService.DeleteFlightTypePath,
      'delete'
    );
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GenericResponse>;
        })
      );
  }

  /**
   * Delete flight type by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteFlightType$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteFlightType(
    params: {
      /**
       * The flight type's id that needs to be deleted
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<GenericResponse> {
    return this.deleteFlightType$Response(params, context).pipe(
      map((r: StrictHttpResponse<GenericResponse>): GenericResponse => r.body)
    );
  }

  /** Path part for operation `updateFlightType()` */
  static readonly UpdateFlightTypePath = '/api/v1/flight-types/{id}';

  /**
   * Update flight type by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateFlightType()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateFlightType$Response(
    params: {
      /**
       * The flight type's id that needs to be updated
       */
      id: number;
      body: UpdateFlightTypeRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<FlightTypeResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      FlightTypeService.UpdateFlightTypePath,
      'patch'
    );
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<FlightTypeResponse>;
        })
      );
  }

  /**
   * Update flight type by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateFlightType$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateFlightType(
    params: {
      /**
       * The flight type's id that needs to be updated
       */
      id: number;
      body: UpdateFlightTypeRequest;
    },
    context?: HttpContext
  ): Observable<FlightTypeResponse> {
    return this.updateFlightType$Response(params, context).pipe(
      map(
        (r: StrictHttpResponse<FlightTypeResponse>): FlightTypeResponse =>
          r.body
      )
    );
  }
}
